// Shared admin helpers — keep CSV downloads, date-range inputs and basic
// admin-API wiring in one place so every admin tab behaves identically.
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Download an admin CSV by streaming a blob, force-saving via an anchor.
 * Matches the existing Bookings export UX so all admin CSVs feel identical.
 *
 * @param {object} opts
 * @param {string} opts.endpoint  — e.g. "/admin/enquiries/export.csv"
 * @param {object} opts.params    — query params (filters, date ranges, etc.)
 * @param {string} opts.pw        — admin password from sessionStorage
 * @param {string} opts.filename  — desired filename (no extension)
 */
export async function downloadAdminCsv({ endpoint, params = {}, pw, filename }) {
  try {
    const cleanParams = {};
    Object.entries(params).forEach(([k, v]) => {
      if (v === undefined || v === null || v === "") return;
      if (typeof v === "boolean") { if (v) cleanParams[k] = "true"; return; }
      cleanParams[k] = v;
    });
    const r = await axios.get(`${API}${endpoint}`, {
      headers: { "x-admin-password": pw },
      params: cleanParams,
      responseType: "blob",
    });
    const blob = new Blob([r.data], { type: "text/csv;charset=utf-8" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `${filename}-${new Date().toISOString().slice(0, 10)}.csv`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);
    toast.success("CSV downloaded");
  } catch (e) {
    toast.error(e?.response?.data?.detail || "Export failed");
  }
}

export const apiBase = API;
